<template>
    <component :is="currentLayout" />
    <Toast />
    <DynamicDialog />
    <ConfirmPopup group="popup"></ConfirmPopup>
    <ConfirmDialog group="dialog"></ConfirmDialog>
    <div id="popups-container"></div>
    <div id="recaptcha-container"></div>
</template>

<script lang="ts" setup>
import DynamicDialog from "primevue/dynamicdialog";
import Toast from "primevue/toast";
import { computed, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useKeybindingsExplanation } from "@/composables/keybindings-explanation";
import { useUnauthorizedAccessDialog } from "@/composables/unauthorized-access-dialog";

import * as Layouts from "@/layouts";
import { useHtmlTitleManager } from "@/composables/html-title-manager";
import { useHotKeys } from "./composables/hotkeys";

const route = useRoute();
const { attach } = useHotKeys();
const { open: openUnauthorizedDialog } = useUnauthorizedAccessDialog();

attach();
useKeybindingsExplanation();
useHtmlTitleManager();

// Handler for unauthorized access events
const handleUnauthorizedAccess = (event: CustomEvent) => {
    openUnauthorizedDialog(event.detail);
};

// Register and clean up event listeners
onMounted(() => {
    window.addEventListener(
        "unauthorized-access",
        handleUnauthorizedAccess as EventListener
    );
});

onUnmounted(() => {
    window.removeEventListener(
        "unauthorized-access",
        handleUnauthorizedAccess as EventListener
    );
});

const currentLayout = computed(() => {
    if (route.meta.layout) {
        if (!(route.meta.layout in Layouts)) {
            throw new Error(`Unknown layout: ${route.meta.layout}`);
        }
        return Layouts[route.meta.layout];
    }
    return Layouts["ApplicationLayout"];
});
</script>

<style scoped>
#navbar-container {
    min-height: 100vh;
    overflow: auto;
}
#popups-container {
    position: absolute;
    z-index: 99;
}
</style>
